import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { IWhistleBlowCategoryListItem, WhistleBlowCategoryListItem } from "ui/Scripts/source/models/whistleBlowCategory/whistleBlowCategoryListItem";
import { IPagePanel } from "../common/pagePanel";
import { RecordPagePanel } from "../record/recordPagePanel";

export interface IWhistleBlowPageData {
    panels: IPagePanel[];
    units: IIdTitleNode[];
    categories: IWhistleBlowCategoryListItem[];
    handlers: IIdTitle[];
}

export class WhistleBlowPageData implements IWhistleBlowPageData {
    panels: RecordPagePanel[];
    units: IdTitleNode[];
    categories: WhistleBlowCategoryListItem[];
    handlers: IdTitle[];

    constructor();
    constructor(obj: IWhistleBlowPageData);
    constructor(obj?: any) {
        this.panels = Base.getTypedArray(obj ? obj.panels : null, RecordPagePanel);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.categories = Base.getTypedArray(obj ? obj.categories : null, WhistleBlowCategoryListItem);
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, IdTitle);
    }
}
